export const scorerStyle = {
	backgroundColor: "var(--dark-background)",
};

export const fncClassNameScorerTotal = () => {
	return "text-bold text-dark-golden-yellow";
};
